import { useUserStore } from '@/store/userStore';
import { supabase } from '@/integrations/supabase/client';

/**
 * Get current user ID from store (fast, no network call)
 * Falls back to auth.getUser() only if store is empty
 */
export async function getCurrentUserId(): Promise<string | null> {
  // Try store first (instant)
  const storeUserId = useUserStore.getState().user?.id;
  if (storeUserId) return storeUserId;
  
  // Fallback to auth query (slow)
  const { data: { user } } = await supabase.auth.getUser();
  return user?.id || null;
}

/**
 * Get current user ID synchronously from store only
 * Returns null if not available (no fallback)
 */
export function getCurrentUserIdSync(): string | null {
  return useUserStore.getState().user?.id || null;
}
